import React, { useState } from 'react';

import './ContactLensRelatedProduct.scss';

export const ContactLensRelatedProduct = props => {
  const { baseImageUrl, list } = props;

  const [selectedItems, setSelectedItems] = useState([]);

  return (
    <div className="contact-lens-related-product">
      <div className="contact-lens-related-product__container">
        <h3 className="contact-lens-related-product__title">Related Products</h3>

        <ul className="contact-lens-related-product__list">
          {list.map(({ id, image, title, subTitle, price }, i) => (
            <li key={`${title}-${i}`} className="contact-lens-related-product__item">
              <div
                className="contact-lens-related-product__icon-heart"
                onClick={() =>
                  setSelectedItems(prev =>
                    prev.includes(id) ? prev.filter(item => item !== id) : [...prev, id]
                  )
                }
              >
                <img
                  alt="Add To Shortlist"
                  src={`${baseImageUrl}/icons/heart-${
                    selectedItems.includes(id) ? 'active' : 'inactive'
                  }.svg`}
                />
              </div>

              <img
                alt={title}
                className="contact-lens-related-product__item-img"
                src={`${baseImageUrl}${image}`}
              />
              <div className="contact-lens-related-product__item-content">
                <h5 className="contact-lens-related-product__item-title">{title}</h5>
                <p className="contact-lens-related-product__item-sub-title">{subTitle}</p>

                <div className="contact-lens-related-product__item-footer">
                  <div className="contact-lens-related-product__item-price-container">
                    <p className="contact-lens-related-product__item-price-after">{price.after}</p>
                    {price.before && (
                      <p className="contact-lens-related-product__item-price">{price.before}</p>
                    )}
                  </div>

                  <a className="contact-lens-related-product__item-view">
                    <span>View</span>
                  </a>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
